<template>
  <t-text-field
    :id="field"
    v-model="value"
    v-bind="{ ...$attrs }"
    :class="[`field-${field}`]"
    name="address-city"
    :autocomplete="autocomplete"
    :error-messages="errors"
    :placeholder="placeholder"
    outlined
    :autofocus="autofocus"
    :loading="loading"
    :success="isValid"
    @blur="validate(value)"
  />
</template>

<script>
import AddressCityField from 'chimera/all/components/form/fields/addressCity/AddressCityField'

export const field = 'future-address-city'
export default {
  name: 'FutureAddressCityField',

  extends: AddressCityField,

  props: {
    field: {
      type: String,
      default: field,
    },
  },
}
</script>
